<template>
  <div
    data-component-element-id="alert"
    class="flex flex-row align-top gap-5 rounded-xs bg-gray-50 shadow-[0_4px_4px_0_rgba(0,0,0,0.05)]"
    :class="{
      'px-5 py-3': size === 'compact',
      'px-5 py-5': size === 'medium',
    }">
    <img data-component-element-id="alertIcon" class="w-6 h-6" :src="imageSource" alt="Info Icon" />

    <div
      class="flex flex-col flex-1 items-start gap-1 text-start"
      :class="{
        'gap-1': size === 'compact',
        'gap-3': size === 'medium',
      }"
    >
      <span
        data-component-element-id="alertTitle"
        class="text-base font-semibold"
        :class="[type === 'error' ? 'text-red-warning' : 'text-jet']">
        <slot name="title">{{ title }}</slot>
      </span>

      <p
        data-component-element-id="alertMessage"
        class="text-sm text-dark-grey">
        <slot name="message">{{ message }}</slot>
      </p>
    </div>

    <button
      v-if="!hideCloseBtn"
      data-component-element-id="alertCloseBtn"
      class="*:hover:opacity-100 *:opacity-60 w-max h-max"
      @click="$emit('close')">
      <img class="w-6 h-6" src="@/static/icons/close.svg" alt="Close Icon" />
    </button>
  </div>
</template>

<script src="./alert.js"></script>
